import React from 'react';
import Routes from './configs/routes';

export default () => <Routes/>;
